import { uniq } from 'lodash'

const useOptions = (data) => {
  const resources = uniq(data.map(i => i.resource)).sort().map(resource => (
    {
      label: resource,
      value: resource
    }
  ))
  
  const locations = uniq(data.map(i => i.location)).sort().map(location => (
    {
      label: location,
      value: location
    }
  ))
  
  const customers = uniq(data.map(i => i.customer)).sort().map(customer => (
    {
      label: customer,
      value: customer
    }
  ))
  
  const booleans = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
    { label: 'Empty', value: null },
  ]
  

  return {
    resources,
    locations,
    customers,
    booleans
  }
}




export default useOptions